import React from 'react'
import { Loader } from 'semantic-ui-react'

import BrandedComponentLoader, { BrandedComponentsList } from '../BrandedComponentLoader'

const LocalLoader = ({ loading, renderChildren, logoLoader, children }) => (
  <>
    {loading &&
      (logoLoader ? (
        <BrandedComponentLoader component={BrandedComponentsList.LocalLoading} />
      ) : (
        <Loader style={{ display: loading ? 'block' : 'none' }} />
      ))}

    {(!loading || renderChildren) && children}
  </>
)

LocalLoader.defaultProps = {
  loading: false,
  renderChildren: false,
  logoLoader: false,
}

export default LocalLoader
